<ngx-spinner
  type="ball-scale-multiple"
  [bdColor]="'rgba(255, 255, 255, 0.7)'"
  template="<img src='assets/imgs/logos/logo-pjus-animada.gif' style='width: 60%; left: 20%;
    position: relative;' />"
></ngx-spinner>
